import React from "react";
import * as css from "./style.module.less";
import { Button, Modal } from "@cloud/atom-ui";
import classNames from "classnames";
import VersionTip from "../version-tip";

export default props => {
  const {
    title,
    showRightBtn,
    btnClick,
    desc,
    headerStyle = {},
    titleEditClick,
    customizedTip = ''
  } = props;
  return (
    <header style={headerStyle} className={css.header}>
      <VersionTip
        style={{ marginBottom: "29px", marginRight: "24px" }}
        content={customizedTip}
      />
      <p className={css["header-title"]}>
        {title}
        {props.titleEditShow && (
          <Button
            className={css["right-btn"]}
            style={{ right: 144 }}
            onClick={() => {
              titleEditClick?.();
            }}
          >
            编辑
          </Button>
        )}

        {showRightBtn && (
          <Button
            className={css["right-btn"]}
            onClick={() => {
              Modal.confirm({
                content: "是否确定删除？",
                onOk: () => btnClick?.(),
                footer: [
                  <Button key="back">取消</Button>,
                  <Button key="submit" type="primary">
                    确定
                  </Button>
                ]
              });
            }}
          >
            删除应用
          </Button>
        )}
      </p>
      {!!desc?.length && (
        <div className={css["header-desc"]}>
          {desc.map((item, index, array) => {
            if (typeof item === "string") {
              return (
                <p
                  key={index}
                  className={classNames({
                    [css["desc-margin"]]: array.length > 1
                  })}
                >{`${array.length > 1 ? index + 1 + "." : ""}${item}`}</p>
              );
            } else if (
              Object.prototype.toString.call(item) === "[object Object]"
            ) {
              return (
                <p key={index}>
                  {`${array.length > 1 ? index + 1 + "." : ""}${item?.text}`}
                  <span
                    onClick={() => {
                      window.open(item?.moreUrl, "_blank");
                    }}
                    style={{ color: "#008DFF", cursor: "pointer" }}
                  >
                    {item?.moreText}
                  </span>
                </p>
              );
            }
            return null;
          })}
        </div>
      )}
    </header>
  );
};
